export default "__VITE_ASSET__CP8KapMX__"